//Header搜尋條件 (昀寬多加)
class HeaderSearchVal {
  constructor() {
    this.nav           = $('#navVal').val();
    this.tabs          = $('.tabs input:radio');
    // this.searchForm    = $('#rwdSearchForm'); //右側側邊搜尋
    this.searchForm    = $('.searchForm'); //全部form底下的搜尋
    // this.searchForm    = $('form'); //全部form底下的搜尋
    this.webSearchForm = $('#webSearchForm'); //網頁版上方搜尋
    this.submitBtn     = $('#submitSearchButton');
    this.ajaxBtn       = $('#searchButton');
    this.getBtn        = $('.searchFormButton'); //get搜尋處理,移除掉post跟ajax
  }

  //搜尋條件處理
  searchConditionProcess() {
    this.getBtn.on('click', () => {
      //把該名字的所有name值加總為陣列，並轉為字串輸出
      function GetCheckedValue(checkBoxName)  { 
        let returnVal = $("input[name='" + checkBoxName + "']:checked").map(function () {
        // let returnVal = $("input[name='" + checkBoxName + "']").is(":checked").prop('checked',true).map(function () {
          return $(this).val();
        }).get();
        //過濾重覆值
        var result = returnVal.filter(function(element, index, arr){
          return arr.indexOf(element) === index;
        });
        return result.join(',');
      } //function GetCheckedValue(checkBoxName)  {
        
      //處理參數
      let keyName = ''; //暫存key值，判斷是否有重覆
      let getURL = this.searchForm.find("input").map(function () {
        // console.log( $(this).attr('name') );
          if($(this).attr('type') === 'radio' || $(this).attr('type') === 'checkbox' ) { //radio、checkbox的陣列處理
            if($(this).is(':checked') == true && $(this).val() != '不限') { //判斷是否有選取
              return $(this).attr('name')+'='+ GetCheckedValue( $(this).attr('name') );
            }
          } else { 
            //非陣列處理
            //判斷空值
            if( $(this).val() != '' && $(this).length != 0 && $(this).attr('name') != 'nav' ) {
              // console.log($(this).attr('name')+'(a)='+encodeURIComponent( $(this).val() ));
              return $(this).attr('name')+'=' + $(this).val();
            }
          }
      }).get(); //傳回時字串，用逗號分隔
      // console.log(getURL);
      //過濾重覆值
      var result = getURL.filter(function(element, index, arr){
        return arr.indexOf(element) === index;
      });

      //判斷業務版
      if( $('input[name="personalId"]').val() !='') {
        var person_id_val = $('input[name="personalId"]').val();
      } else {
        var person_id_val = '';
      }


      let getURLString = Array.from(result).join('&'); //篩選完重覆，陣列轉字串
      let formAction = this.searchForm.attr('action'); //抓傳值路徑(買屋、租屋、新成屋頁面)
      location.href='./' + person_id_val + formAction + '&q=' + encodeURIComponent(getURLString); //轉址
    });
  }

  //搜尋物件類別
  selectRealtyClass() {
    //判斷form的action路徑(一開始進入的頁面)
    let classNumberValString = $('#areaSearch').attr('vv'); //選取的中文字
    let navValue = $('.scrollBox #nav').val(); //目前頁面
    // console.log(classNumberValString+":::"+navValue);
    if(classNumberValString && classNumberValString != 'Array') {
      if(classNumberValString === '租屋'){
          this.searchForm.attr('action','?nav=rent'); //租屋頁面
      }else if(classNumberValString === '新成屋'){
          this.searchForm.attr('action','?nav=new'); //新成屋頁面
      }else{
          this.searchForm.attr('action','?nav=buy'); //買屋頁面
      }
    } else {
      if(navValue == 'buy' || navValue == 'rent' || navValue == 'all_object') {
        if(navValue == 'rent') {
            this.searchForm.attr('action','?nav=rent'); //租屋頁面
        } else if(navValue == 'all_object') {
            this.searchForm.attr('action','?nav=all_object'); //全物件頁面  
        } else {
            this.searchForm.attr('action','?nav=buy'); //買屋頁面
        }
      }
    }

    this.tabs.each((i, e) => {
      $(e).on('click', () => {
        let $menuValue   = $(e).val();                 //抓出選擇的項目
        let $nav         = $('.scrollBox #nav').val(); //目前所在的頁面
        let $moreClasses = $('.more_classes input:checkbox');

        //---判斷其它form是否有一樣的項目，並做同步選取
        let checkName   = $(e).attr('name'); //找出選取的name值
        let checkVal    = $(e).attr('value'); //找出選取的值
        let checkStatus = $(e).prop('checked'); //勾選狀態

        $('form input[name="'+checkName+'"]').each((index, element) => {
            if(checkVal == $(element).attr('value')) {
              $(element).prop('checked',checkStatus);    
            } //if(checkVal == $(element).attr('value')) {
        });
        //---判斷其它form是否有一樣的項目，並做同步選取
        
        if($menuValue === '租屋'){
          if($nav != 'rent'){
            this.searchForm.attr('action','?nav=rent'); //租屋頁面
          }
        }else if($menuValue === '新成屋'){
          if($nav != 'new'){
            this.searchForm.attr('action','?nav=new'); //新成屋頁面
          }
        }else{
          // if($nav != 'buy'){
            this.searchForm.attr('action','?nav=buy'); //買屋頁面
          // }

          switch($menuValue){
            case '住宅':
              $moreClasses.each((i, e) => {
                if($(e).val() === '套房' || $(e).val() === '大樓華廈' || $(e).val() === '無電梯公寓' || $(e).val() === '透天別墅' || $(e).val() === '土地(其他)'){
                  $(e).attr('checked', true);
                }
              });
              break;
            case '店面':
              $moreClasses.each((i, e) => {
                if($(e).val() === '套房' || $(e).val() === '大樓華廈' || $(e).val() === '無電梯公寓' || $(e).val() === '透天別墅' || $(e).val() === '透天店面' || $(e).val() === '樓店' || $(e).val() === '土地(其他)'){
                  $(e).attr('checked', true);
                }
              });
              break;
            case '辦公':
              $moreClasses.each((i, e) => {
                if($(e).val() === '套房' || $(e).val() === '大樓華廈' || $(e).val() === '無電梯公寓' || $(e).val() === '透天別墅' || $(e).val() === '土地(其他)' ){
                  $(e).attr('checked', true);
                }
              });
              break;
            case '工業地':
              $moreClasses.each((i, e) => {
                if($(e).val() === '廠房' || $(e).val() === '工業地' || $(e).val() === '土地(其他)' || $(e).val() === '其他' ) {
                  $(e).attr('checked', true);
                }
              });
              break;
            
            // case '車位':
            //   break;
            
            case '土地':
            case '其它':
              $moreClasses.each((i, e) => {
                if($(e).val() === '土地(其他)' || $(e).val() === '其他'){
                  $(e).attr('checked', true);
                }
              });
              break;
          }
        }

      }); //$(e).on('click', () => {
    });
  }
  sendSearch() {
    //搜尋物件類別
    this.selectRealtyClass();
    this.searchConditionProcess(); //搜尋條件處理(get方式)

    //送出搜尋
    this.searchForm.find('input[name=keyword_value]').bind('keypress', (e) => {

      if(e.keyCode == 13 && this.nav == ''){
        $('body').addClass('active');
        $('.searchFormButton').click(); //按下enter後觸發送出鈕
      }
    });
    this.submitBtn.on('click', () => {
      $('body').addClass('active');
    });
  }
}




//表單送出 - 客服信箱 / 預約看屋 / 降價通知 / 買屋留言 (朝凱多加)
class SendForm {
  constructor() {
    this.msg          = '資料送出後將無法修改，是否確定送出？';
    this.fc1Ajax      = 'ajax_buy_reserve.php';
    this.fc2Ajax      = 'ajax_buy_pr.php';
    this.fc3Ajax      = 'ajax_buy_message.php';
    this.contactAjax  = 'ajax_service.php';
    // this.personalAjax = 'ajax_personal_form_process.php';
    this.personalAjax = 'ajax_buy_reserve.php'; 
  }
  //Ajax 
  ajaxFormData(ajaxFile, formData) {
    // console.log('進入ajax');
    $.post(ajaxFile, formData, (json) => {
      // alert(json.msg);
      // location.reload();
      Swal.fire({
          title: json.msg,
          icon: 'success',
          confirmButtonText: '確定',
          customClass: {
            popup: 'my-swal-popup-class',
            container: 'my-swal-container-class',
            content: 'my-swal-content-class'
          }

      }).then((result) => {
          if (result.isConfirmed) {
              location.reload();
          }
      });
    }, 'json').fail(function(xhr, status, error) { 
      //console.log(xhr.responseText); 
    });
  }
  //Lightbox表單送出 - 預約看屋 / 降價通知 / 買屋留言 (朝凱多加)
  realtyForm() { 
    // console.log('進入realy');
    const $form = $('#realtyForm');
    $form.submit((e) => {
      e.preventDefault();
      Swal.fire({
        title: this.msg,
        showDenyButton: true,
        confirmButtonText: '是',
        denyButtonText: `否`,
        customClass: {
            popup: 'my-swal-popup-class',
            container: 'my-swal-container-class',
            content: 'my-swal-content-class'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          let type = $form.data('type');
          let data = $form.serialize(); //序列化資料傳送
          if(type == 'fc1'){
            //預約看屋
            this.ajaxFormData(this.fc1Ajax, data);
          }else if(type == 'fc2'){
            //降價通知
            this.ajaxFormData(this.fc2Ajax, data);
          }else if(type == 'fc3'){
            //買屋留言
            this.ajaxFormData(this.fc3Ajax, data);
          }
          return false;
        } else {
          return false;
        }
      });
      /*
      if(confirm(this.msg)){
        let type = $form.data('type');
        let data = $form.serialize(); //序列化資料傳送
        if(type == 'fc1'){
          //預約看屋
          this.ajaxFormData(this.fc1Ajax, data);
        }else if(type == 'fc2'){
          //降價通知
          this.ajaxFormData(this.fc2Ajax, data);
        }else if(type == 'fc3'){
          //買屋留言
          this.ajaxFormData(this.fc3Ajax, data);
        }
        return false;
      }else{
        return false;
      }
      */
    });
  }
  
  //Aside表單送出 - 預約看屋 / 降價通知 / 買屋留言 (朝凱多加)
  asideRealtyForm() {
    // console.log('進入aside');
    const $form = $('#asideRealtyForm');
    $form.submit((e) => {
      e.preventDefault();
      Swal.fire({
        title: this.msg,
        showDenyButton: true,
        confirmButtonText: '是',
        denyButtonText: `否`,
        customClass: {
            popup: 'my-swal-popup-class',
            container: 'my-swal-container-class',
            content: 'my-swal-content-class'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          let type = $form.find('.typeBtn input:checked').val();
          let data = $form.serialize(); //序列化資料傳送
          if(type == 'fc1'){
            //預約看屋
            // console.log('fc1');
            this.ajaxFormData(this.fc1Ajax, data);
          }else if(type == 'fc2'){
            //降價通知
            // console.log('fc2');
            this.ajaxFormData(this.fc2Ajax, data);
          }else if(type == 'fc3'){
            //買屋留言
            // console.log('fc3');
            this.ajaxFormData(this.fc3Ajax, data);
          }
          return false;
        } else {
          return false;
        }
      });
        /*
      if(confirm(this.msg)){
        let type = $form.find('.typeBtn input:checked').val();
        let data = $form.serialize(); //序列化資料傳送
        if(type == 'fc1'){
          //預約看屋
          // console.log('fc1');
          this.ajaxFormData(this.fc1Ajax, data);
        }else if(type == 'fc2'){
          //降價通知
          // console.log('fc2');
          this.ajaxFormData(this.fc2Ajax, data);
        }else if(type == 'fc3'){
          //買屋留言
          // console.log('fc3');
          this.ajaxFormData(this.fc3Ajax, data);
        }
        return false;
      }else{
        return false;
      }
      */


    });
  }

  //客服信箱
  contactForm() {
    // console.log('進入客服');
    const $form = $('#contactForm');
    $form.submit((e) => {
      e.preventDefault();
      Swal.fire({
        title: this.msg,
        showDenyButton: true,
        confirmButtonText: '是',
        denyButtonText: `否`,
        customClass: {
            popup: 'my-swal-popup-class',
            container: 'my-swal-container-class',
            content: 'my-swal-content-class'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          let data = $form.serialize(); //序列化資料傳送
          this.ajaxFormData(this.contactAjax, data);
        } else {
          return false;
        }
      });
      /*
      if(confirm(this.msg)){
        let data = $form.serialize(); //序列化資料傳送
        this.ajaxFormData(this.contactAjax, data);
      }else{
        return false;
      }
      */
    });
  }
  //業務個人
  personalForm() {
    // console.log('業務個人');
    const $form = $('#personalForm');
    $form.submit((e) => {

      e.preventDefault();
      if(confirm(this.msg)){
        let type = $form.data('type'); //表單類型
        let data = $form.serialize(); //序列化資料傳送
        // this.ajaxFormData(this.personalAjax, data);
        if(type == 'fc1'){
          //預約看屋
          this.ajaxFormData(this.fc1Ajax, data);
        }else if(type == 'fc2'){
          //降價通知
          this.ajaxFormData(this.fc2Ajax, data);                                                                 
        }else if(type == 'fc3'){
          //買屋留言
          this.ajaxFormData(this.fc3Ajax, data);
        }

      }else{
        return false;
      }
    });
  }
}




//輸出
export {HeaderSearchVal, SendForm};


// WEBPACK FOOTER //
// ./js_new/other.js